<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :title="title"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body
      class="charge-apply-dialog"
      :before-close="handleClose"
      width="860px"
    >
      <div>
        <h1>{{ workflowTitle }}</h1>
        <table class="details-table" cellpadding="0" cellspacing="0">
          <tr v-if="!isApply">
            <td class="header">{{ $t('CargoMsg.Cargo_ApprovalSerialNumber') }}</td>
            <td class="values">{{ processInfo.documentProcessNo }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_StartDate') }}</td>
            <td class="values">{{ processInfo.createDate }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_Applicant') }}</td>
            <td class="values">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', changeCharge.createdBy, 'chineseName') }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_BusinessDocNo') }}</td>
            <td class="values">{{ changeCharge.jobNo }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_BusinessType') }}</td>
            <td class="values">{{ lobLabel() }}</td>
            <td class="header">{{ $t('CargoMsg.Cargo_InitiateBranchCompany') }}</td>
            <td class="values">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', !processInfo ? $store.getters.currentOfficeId : processInfo.officeId, 'chineseName') }}</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_GrossProfitMarginBeforeChange') }}</td>
            <td class="values">{{ changeCharge.jobGrossProfitRateOld }}%</td>
            <td class="header">{{ $t('CargoMsg.Cargo_GrossProfitMarginAfterChange') }}</td>
            <td class="values">{{ changeCharge.jobGrossProfitRate }}%</td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_Remarks') }}</td>
            <td class="values">{{ changeCharge.remarks }}</td>
          </tr>
        </table>
        <div v-if="!isApply" style="margin-top: 20px; margin-bottom: 20px; width: 100%; height: 30px">
          <el-button style="float: right" type="primary" @click="onViewChargeRequest">{{ $t('CargoMsg.Cargo_ViewChangeData') }}</el-button>
        </div>
        <div v-if="!isApply" style="border: 1px solid #E3E3E3;">
          <div style="margin: 5px">
            <el-tabs v-model="activeName">
              <el-tab-pane v-if="isApprove" :label="$t('CargoMsg.Cargo_ApprovalComments')" name="comments">
                <process-content :form="form" />
              </el-tab-pane>
              <el-tab-pane :label="$t('CargoMsg.Cargo_ApprovalCommentsRecord')" name="record">
                <div style="max-height: 130px; overflow: auto">
                  <div v-for="(record, index) in records" :key="index">
                    <el-card class="box-card">
                      <div v-if="record.actionType !== Action_Type_Submit.code" style="display: flex">
                        <span>{{ $t('CargoMsg.Cargo_Approver') }}： </span>
                        <span>{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName') }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_ApprovalComments') }}： </span>
                        <span>{{ WorkflowUtil.getActionName(record.actionType) }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_Remarks') }}： </span>
                        <span>{{ record.remark }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_ApprovalTime') }}： </span>
                        <span>{{ record.createTime }}</span>
                      </div>
                      <div v-else style="display: flex">
                        <span>{{ $t('CargoMsg.Cargo_Initiator') }}： </span>
                        <span>{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', record.userId, 'chineseName') }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_Remarks') }}： </span>
                        <span>{{ record.remark }}</span>
                        <span style="margin-left: 30px">{{ $t('CargoMsg.Cargo_StartTime') }}： </span>
                        <span>{{ record.createTime }}</span>
                      </div>
                      <div v-show="record.files && record.files.length > 0" style="margin-top: 10px;cursor: pointer;">
                        <div v-for="(file, index) in record.files" :key="index" style="display: inline-block;" class="file-style">
                          <div style="margin-left: 10px; display: flex" @click="downloadFile(file.fileId)">
                            <i class="el-icon-paperclip" />
                            <span class="file-name">{{ file.fileName }}</span>
                            <span style="color: darkgray;">{{ WorkflowUtil.fileSizeLabel(file.fileSize) }}</span>
                          </div>
                        </div>
                      </div>
                    </el-card>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div v-if="isApply && hasBtn" style="margin-top: 10px; margin-bottom: 10px">
          <span style="margin-left: 10px">{{ $t('CargoMsg.Cargo_Remarks') }}:</span>
          <process-content :form="form" />
        </div>
      </div>
      <template slot="footer" style="height: 65px">
        <div style="display: flex">
          {{ $t('CargoMsg.Cargo_RefuseAndReturnNode') }}
        </div>
        <div style="float: right; display: flex">
          <el-button v-for="(btn, index) in btnList" :key="index" :title="btn.title" :type="btn.color" @click="onAction(btn)">{{ btn.actionName }}</el-button>
          <el-button @click="handleClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 更改前后对比弹窗 -->
    <before-and-after-comparison-dialog-bpm
      v-if="beforeAndAfterComparisonDialogBpm.visible"
      :visible.sync="beforeAndAfterComparisonDialogBpm.visible"
      :tips="false"
      :change-reason="beforeAndAfterComparisonDialogBpm.changeReason"
      :ar-charge-before="beforeAndAfterComparisonDialogBpm.arChargeBefore"
      :ap-charge-before="beforeAndAfterComparisonDialogBpm.apChargeBefore"
      :ar-charge-after="beforeAndAfterComparisonDialogBpm.arChargeAfter"
      :ap-charge-after="beforeAndAfterComparisonDialogBpm.apChargeAfter"
      :charge-original-profit="beforeAndAfterComparisonDialogBpm.chargeOriginalProfit"
      :charge-change-profit="beforeAndAfterComparisonDialogBpm.chargeChangeProfit"
      :ap-tip="beforeAndAfterComparisonDialogBpm.apTip"
      :ar-tip="beforeAndAfterComparisonDialogBpm.arTip"
      @onCancel="() => { beforeAndAfterComparisonDialogBpm.visible = false }"
    />

    <!-- 加签 人员配置 -->
    <choose-user-dialog-add
      v-if="chooseUserDialogAdd.visible"
      :title="$t('CargoMsg.Cargo_SelectSigner')"
      :visible.sync="chooseUserDialogAdd.visible"
      :value="chooseUserDialogAdd.userIds"
      @close="chooseUserDialogAdd.visible=false"
      @change="addSignature"
    />
    <!-- 转签 人员配置 -->
    <choose-user-dialog-transfer
      v-if="chooseUserDialogTransfer.visible"
      :title="$t('CargoMsg.Cargo_SelectTransferor')"
      :visible.sync="chooseUserDialogTransfer.visible"
      :value="chooseUserDialogTransfer.userIds"
      @close="chooseUserDialogTransfer.visible=false"
      @change="transferSignature"
    />
  </div>
</template>
<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getAddSignatureInfo, workflowAction, workflowCheck } from '@/api/workflow'
import { getLoading } from '@/utils/utilBaseElement'
import ProcessContent from '@/components/Cargo/Common/Wrokflow/processContent'
import { deleteFile, uploadStorage } from '@/api/storage'
import { cache } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { getChangeChargeBpm } from '@/api/clearing/changeChargeBpm'
import beforeAndAfterComparisonDialogBpm
  from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/beforeAndAfterComparisonDialogBpm'
import ApprovalCommentsAndBtns from '@/components/Cargo/Common/Wrokflow/approvalCommentsAndBtns'
import {
  Action_Type_Add_Signature,
  Action_Type_Appoint,
  Action_Type_Approve,
  Action_Type_Auto_Press_To_Do,
  Action_Type_Cancel_Signature,
  Action_Type_Reject, Action_Type_Return, Action_Type_Submit,
  Action_Type_Transfer_Signature,
  APPLICATION_DIMENSION_JOB_CHARGE,
  CHARGE_CHANGE
} from '@/class/cargo/model/parameters/WorkflowConstants'
import ChooseUserDialogAdd
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import ChooseUserDialogTransfer
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog'
import URL from '@/api/urlTranslator'

export default {
  name: 'ChargeApplyDialog',
  components: { ProcessContent, cargoAdvanceSelect, beforeAndAfterComparisonDialogBpm, ApprovalCommentsAndBtns, ChooseUserDialogAdd, ChooseUserDialogTransfer },
  props: {
    title: { type: String, default: () => '' },
    processInfo: { type: Object, default: () => {} }, // 审核流程id
    changeCharge: { type: Object, default: () => {} },
    type: { type: String, default: () => '' }, // apply-申请，look-查看，approve-审批
    status: { type: Number, default: () => null }, //
    records: { type: Array, default: () => [] }, // 审核记录
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      loading: null,
      form: {
        fileList: [],
        remark: ''
      },
      btnList: [],
      ColumnUtils: ColumnUtils,
      WorkflowUtil: WorkflowUtil,
      TYPE_NAMES: TYPE_NAMES,
      showChargeDialog: false,
      activeName: 'comments',
      approvalRemark: '',
      documentProcessId: '',
      storageURL: '',
      workflowName: '',
      // 更改前后对比
      beforeAndAfterComparisonDialogBpm: {
        visible: false,
        apTip: '',
        arTip: '',
        appendToBody: false,
        changeReason: '', // 更改原因
        arChargeBefore: [], // 修改前
        apChargeBefore: [], // 修改前
        arChargeAfter: [], // 修改后,
        apChargeAfter: [], // 修改后,
        chargeOriginalProfit: [], // 整票预估利润：修改前
        chargeChangeProfit: [] // 整票预估利润：修改后
      },
      APPLICATION_DIMENSION_JOB_CHARGE: APPLICATION_DIMENSION_JOB_CHARGE,
      skipApprove: true, // 跳过审核，为了达到刚进来是不显示弹窗的效果，默认值为true；在check之后，若不跳过审核 或 未匹配到审批流，都将该值赋false，即不跳过审核，即显示审批弹窗
      chooseUserDialogAdd: {
        visible: false,
        userIds: []
      },
      chooseUserDialogTransfer: {
        visible: false,
        userId: null
      },
      btn: null,
      Action_Type_Submit: Action_Type_Submit
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    hasBtn() {
      return this.btnList && this.btnList.length > 0
    },
    isApply() {
      return this.type === 'apply'
    },
    isApprove() {
      return this.type === 'approve' && this.hasBtn
    },
    workflowTitle() {
      return this.workflowName || (this.processInfo ? this.processInfo.workflowName : '')
    },
    readonly() { // 付款申请单是否可编辑
      return (this.processInfo && !!this.processInfo.isClosed) || this.btnList.length === 0 || this.btnList.filter(btn => btn.actionType === Action_Type_Approve.code).length === 0
    },
    innerVisible: {
      get() {
        // 当提交时，skipApprove=true跳过审核，不展示弹窗
        return this.visible && (this.type === 'look' || !this.skipApprove)
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  async created() {
    this.storageURL = cache.config.get('StorageURL')
    if (this.type !== 'look' || (this.processInfo && this.processInfo.state === 0)) {
      await this.init()
    }
    this.activeName = !this.isApprove ? 'record' : 'comments'
  },
  methods: {
    async init() {
      const params = {
        documentConfigId: CHARGE_CHANGE.code,
        docId: this.changeCharge.uuid,
        officeId: this.$store.getters.currentOfficeId,
        documentProcessId: this.processInfo ? this.processInfo.documentProcessId : null
      }
      await workflowCheck(params).then(res => {
        if (res.data && res.data.skipApprove) {
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.$emit('closeAndRefresh')
          return
        }
        this.skipApprove = false
        if (res.data && res.data.actions && res.data.actions.length > 0) {
          const btns = res.data.actions
          for (const btn of btns) {
            btn.color = btn.actionType > Action_Type_Approve.code && [Action_Type_Auto_Press_To_Do.code, Action_Type_Add_Signature.code,
              Action_Type_Transfer_Signature.code, Action_Type_Appoint.code, Action_Type_Cancel_Signature.code].indexOf(btn.actionType) === -1 ? 'danger' : 'primary'
            btn.title = btn.actionType === Action_Type_Reject.code ? this.$t('CargoMsg.Cargo_RefuseTitle') : btn.actionType === Action_Type_Return.code ? this.$t('CargoMsg.Cargo_ReturnTitle') : ''
          }
          this.documentProcessId = res.data.documentProcessId
          this.workflowName = res.data.workflowName
          this.btnList = btns
        }
      }).catch(reason => {
        // 未匹配到审批流且抛异常时，不跳过审核
        this.skipApprove = false
      })
    },
    // 按钮动作
    onAction(btn) {
      this.btn = btn
      // 【加签动作】
      if (btn.actionType === Action_Type_Add_Signature.code) {
        getAddSignatureInfo({ documentProcessId: this.documentProcessId }).then(res => {
          if (res.data.userIds && res.data.userIds.length > 0) {
            this.chooseUserDialogAdd.userIds = res.data.userIds
          }
          this.chooseUserDialogAdd.visible = true
        })
        return
      }
      // 【转签动作】
      if (btn.actionType === Action_Type_Transfer_Signature.code) {
        this.chooseUserDialogTransfer.visible = true
        return
      }
      this.doAction(btn)
    },
    doAction(btn) {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureToDo', [btn.actionName]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        this.loading = getLoading()
        await this.upload()
        const params = {
          documentConfigId: CHARGE_CHANGE.code,
          docId: this.changeCharge.uuid,
          docNo: this.changeCharge.jobNo,
          actionId: btn.id,
          remark: this.form.remark,
          fileList: this.form.fileList,
          actionType: btn.actionType,
          officeId: !this.processInfo ? this.$store.getters.currentOfficeId : this.processInfo.officeId,
          documentProcessId: this.documentProcessId,
          applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code,
          signatureUserId: this.chooseUserDialogAdd.userIds && this.chooseUserDialogAdd.userIds.length > 0 ? this.chooseUserDialogAdd.userIds.join(',') : this.chooseUserDialogTransfer.userId,
          nodeId: !this.processInfo ? null : this.processInfo.nodeId
        }
        workflowAction(params).then(res => {
          this.$message.success(btn.actionName + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
          this.$emit('closeAndRefresh')
        }).catch(reason => {
          // 操作失败 且存在附件的情况下，删除附件
          this.removeFile()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    addSignature(userIds) {
      getAddSignatureInfo({ documentProcessId: this.documentProcessId }).then(res => {
        // 不允许对自己‘取消加签’
        if (res.data.userIds && res.data.userIds.length > 0) {
          if (res.data.userIds.indexOf(this.$store.getters.userId) !== -1 && userIds.indexOf(this.$store.getters.userId) === -1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CancelAddSignature'))
            return
          }
        }
        // 不允许对自己‘加签’
        if ((!res.data.userIds || res.data.userIds.indexOf(this.$store.getters.userId) === -1) && userIds.indexOf(this.$store.getters.userId) !== -1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AddSignatureSelf'))
          return
        }
        // 不允许对‘已审批’或‘已委派’的人‘取消加签’
        if (res.data.fixUserIds && res.data.fixUserIds.length > 0) {
          for (const userId of res.data.fixUserIds) {
            if (userIds.indexOf(userId) === -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CancelAddSignatureNotSupport'))
              return
            }
          }
        }
        // 会签下，不允许对当前节点人加签
        if (res.data.disableAddSignatureUserIds && res.data.disableAddSignatureUserIds.length > 0) {
          for (const userId of userIds) {
            if (res.data.disableAddSignatureUserIds.indexOf(userId) !== -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_AddSignatureCurrentNode'))
              return
            }
          }
        }
        this.chooseUserDialogAdd.visible = true
        this.chooseUserDialogAdd.userIds = userIds
        this.doAction(this.btn)
      })
    },
    transferSignature(userIds) {
      if (!userIds || userIds.length === 0) {
        return
      }
      // 只允许选择一个人‘转签人’
      if (userIds.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      // 不允许选择自己作为‘转签人’
      if (userIds[0] === this.$store.getters.userId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TransferSignatureSelf'))
        return
      }
      this.chooseUserDialogTransfer.visible = true
      this.chooseUserDialogTransfer.userId = userIds[0]
      this.doAction(this.btn)
    },
    handleClose() {
      this.innerVisible = false
      this.$emit('close')
    },
    // 更改前后对比
    onViewChargeRequest() {
      const changeChargeUuid = this.changeCharge.uuid
      if (StrUtils.isEmpty(changeChargeUuid)) return
      const requestBody = { changeChargeKey: changeChargeUuid, branchId: !this.processInfo ? this.$store.getters.currentOfficeId : this.processInfo.officeId }
      this.loading = getLoading()
      console.log('getChangeChargeBpm', requestBody)
      getChangeChargeBpm(requestBody).then(res => {
        const changeCharge = res.data
        this.beforeAndAfterComparisonDialogBpm.arChargeBefore = []
        this.beforeAndAfterComparisonDialogBpm.apChargeBefore = []
        const originalChargeUuidArMap = new Map()
        const originalChargeUuidApMap = new Map()
        if (changeCharge.chargeOriginals) {
          for (const data of changeCharge.chargeOriginals) {
            if (data.receivable) {
              if (data.uuid && !originalChargeUuidArMap[data.uuid]) {
                originalChargeUuidArMap.set(data.uuid, originalChargeUuidArMap.size + 1)
                data.originalSerialNo = originalChargeUuidArMap.get(data.uuid)
              }
              this.beforeAndAfterComparisonDialogBpm.arChargeBefore.push(data)
            } else {
              if (data.uuid && !originalChargeUuidApMap[data.uuid]) {
                originalChargeUuidApMap.set(data.uuid, originalChargeUuidApMap.size + 1)
                data.originalSerialNo = originalChargeUuidApMap.get(data.uuid)
              }
              this.beforeAndAfterComparisonDialogBpm.apChargeBefore.push(data)
            }
          }
        }
        this.beforeAndAfterComparisonDialogBpm.arChargeAfter = []
        this.beforeAndAfterComparisonDialogBpm.apChargeAfter = []
        if (changeCharge.chargeChanges) {
          for (const data of changeCharge.chargeChanges) {
            if (data.receivable) {
              data.originalSerialNo = originalChargeUuidArMap.get(data.originalChargeUuid)
              this.beforeAndAfterComparisonDialogBpm.arChargeAfter.push(data)
            } else {
              data.originalSerialNo = originalChargeUuidApMap.get(data.originalChargeUuid)
              this.beforeAndAfterComparisonDialogBpm.apChargeAfter.push(data)
            }
          }
        }
        this.beforeAndAfterComparisonDialogBpm.changeReason = changeCharge.changeReason
        // 整票预估利润
        this.beforeAndAfterComparisonDialogBpm.chargeOriginalProfit = []
        this.beforeAndAfterComparisonDialogBpm.chargeOriginalProfit = changeCharge.chargeOriginalProfit
        this.beforeAndAfterComparisonDialogBpm.chargeChangeProfit = []
        this.beforeAndAfterComparisonDialogBpm.chargeChangeProfit = changeCharge.chargeChangeProfit
        this.beforeAndAfterComparisonDialogBpm.apTip = changeCharge.apTip
        this.beforeAndAfterComparisonDialogBpm.arTip = changeCharge.arTip
        this.beforeAndAfterComparisonDialogBpm.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    // 上传附件
    async upload() {
      const rows = this.form.fileList.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = p
            params.documentType = 'workflow'
            return uploadStorage(params).then(res => {
              p.fileId = res.data
            })
          })
        )
      } catch {
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          `上传成功:${uploadSuccessCount}个,上传失败:${uploadFailCount}个.`,
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      }
    },
    // 动作提交失败，则删除附件
    removeFile() {
      const rows = this.form.fileList.filter(p => p.fileId)
      if (rows.length === 0) {
        return
      }
      Promise.all(
        Array.from(rows, p => {
          return deleteFile(p.fileId).then(res => {
          })
        })
      )
    },
    downloadFile(fileId) {
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    },
    lobLabel() {
      return SystemConstants.getCommonState(this.changeCharge.lob, SystemConstants.LOBS).chineseName
    }
  }
}
</script>

<style lang="scss">
  .charge-apply-dialog{
    width: 100%;
    .el-dialog__footer{
      height: 60px;
    }
    h1{
      text-align: center;
    }
    tr{
      td {
        border: 1px solid #DCDFE6;
        padding: 5px;
        height: 35px;
        text-align: center;
        &.header {
          width: 15%;
          background-color: rgba(238, 248, 255, 1);
        }
        &.values {
          width: 35%;
          min-width: 100px;
        }
      }
    }
    .el-upload-dragger{
      margin-top: 10px;
      height: 40px;
      width: 130px;
      .el-icon-upload{
        margin: 15px 10px 16px !important;
        display: inline-block;
        font-size: 24px;
        line-height: 50px;
      }
    }
    .drop-uploader-icon{
      height: 100%; display: flex; align-items: center; justify-content: center;
    }
    .file-style{
      margin-top: 2px;
      width: 210px;
      height: 15px;
      background: linear-gradient(135deg,#f7faff, #ffffff);
      border-radius: 2px;
    }
    .file-name{
      width: 60%;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-input.el-input--mini {
      width: 100%;
      height: 100%;
      .el-input__inner{
        width: 100%;
        height: 100%;
      }
    }
    .el-input.el-input--mini.el-input--suffix{
      width: 100%;
      height: 100%;
      .el-input__inner{
        width: 100%;
        height: 100%;
      }
    }
    .el-select.el-select--mini{
      width: 100%;
      height: 100%;
      .el-input.el-input--mini.el-input--suffix{
        width: 100%;
        height: 100%;
        .el-input__inner{
          width: 100%;
          height: 100%;
        }
      }
    }
    .cargo-advance-select-wrapper{
      width: 100%;
      height: 100%;
      .el-select.el-select--mini{
        width: 100%;
        height: 100%;
        .el-input__inner{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
